const deviceConnect = state => state.metrics.deviceConnect;

export default deviceConnect;
